import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { DealCardAction as m } from "../../../types/Deal/index.js";
import { StoreContainer as p, StoreText as f, StoreLink as S, VerifiedStoreIcon as x } from "./style.js";
import { useTranslation as C } from "../../../hooks/useTranslation/index.js";
import { HexagonCheck as E } from "@pelando/fontawesome/icons";
const I = "verified-store-icon", D = ({
  name: t,
  link: r = "",
  text: i,
  slug: n,
  isOnboardingCard: l,
  dispatch: s,
  ...a
}) => {
  const { t: c } = C("common"), d = c("deal-store-label");
  return /* @__PURE__ */ o(p, { ...a, children: [
    /* @__PURE__ */ e(f, { children: i || d }),
    /* @__PURE__ */ o("div", { style: { display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ e(
        S,
        {
          onClick: () => s({
            payload: { storeSlug: n },
            type: m.ON_STORE_CLICK
          }),
          title: t,
          url: r,
          disablePointerEvents: l,
          children: t
        }
      ),
      /* @__PURE__ */ e(
        x,
        {
          icon: E,
          role: "presentation",
          "data-testid": I
        }
      )
    ] })
  ] });
};
export {
  D as DealStoreLabel,
  I as FEED_VERIFIED_STORE_ICON
};
